import React from "react";
import INFTUserData from "../models/INFTUserData"
import { ProfileServices } from "./Services";

const useNFTUserData = (address: string, noCache = false) => {

    const [userData, setUserData] = React.useState<INFTUserData | undefined>(undefined);
    const [loading, setLoading] = React.useState<boolean>(true);

    const getDataFromCache = () => {
        try {
            let data = sessionStorage.getItem(address?.toLowerCase());
            if (data && typeof data == "string" && data != "-1") {
                return JSON.parse(data);
            } else {
                return null;
            }
        } catch (error) {
            return null;
        }
    }

    React.useEffect(() => {
        let isCancelled = false;

        if (address && address != "wallet") {
            let cacheData = getDataFromCache();
            if (cacheData && !noCache) {
                if (!isCancelled) {
                    setUserData(cacheData);
                    setLoading(false);
                }
            } else {
                ProfileServices.GetUserProfileData(address).then(res => {
                    if (!isCancelled) {
                        sessionStorage.setItem(address?.toLowerCase(), JSON.stringify(res));
                        setUserData(res);
                        setLoading(false);
                    }
                }).catch(e => {
                    if (!isCancelled) {
                        sessionStorage.setItem(address?.toLowerCase(), "-1");
                        setLoading(false);
                    }
                });
            }
        }

        return () => {
            isCancelled = true;
        }
    }, [noCache, address])

    return { userData, loading };
}

export default useNFTUserData;